import React from "react";
import MenuItem from "./menuItem";
import MenuItemDivider from "./menuItemDivider";
import YourRepresentative, {
  RepTypes,
} from "../yourRepresentative/yourRepresentative";
import NavigationTokensService from "../../utilities/navigationTokensService";
import NavigationTokens from "../../constants/navigationTokens";
import MenuItemService from "../../utilities/menuItemService";
import YourBillingCycle from "../yourBillingCycle/yourBillingCycle";
import { Subscription } from "rxjs";
import ConfigProps from "../../constants/configProps";
import ConfigPropService from "../../utilities/configPropService";
import { WBMUrlService } from "@wbmason/url-service";
import { BaseHostUrlService } from "../../utilities/baseHostUrlService";
import EnvironmentService from "../../utilities/environmentService";
import { forkJoin } from 'rxjs';

export interface IAccountAndPaymentsMenuProps {
  [key: string]: unknown; // placeholder because there are no properties
}

export interface IAccountAndPaymentsMenuState {
  invoicesAndPaymentsHref: string;
  invoiceHistoryHref: string;
  manageCreditCardsHref: string;
  manageAddressesHref: string;
  manageCheckingAccountsHref: string;
  reportsHref: string;
  usersHref: string;
  groupsHref: string;
  displayHistory: boolean;
  displayAdvancedReporting: boolean;
  displayUsers: boolean;
  displayGroups: boolean;
  displayCreditCards: boolean;
  displayAddresses: boolean;
  displayManageAch: boolean;
  displayAccountCenterDashboard: boolean;
  manageRecurringPaymentsHref: string;
  displayRecurringPayments: boolean;
}

class AccountAndPaymentsMenu extends React.Component<
  IAccountAndPaymentsMenuProps,
  IAccountAndPaymentsMenuState
> {
  subsToUnsubscribe: Subscription[] = [];

  constructor(props: IAccountAndPaymentsMenuProps) {
    super(props);

    this.state = {
      invoicesAndPaymentsHref: "",
      invoiceHistoryHref: "",
      manageCreditCardsHref: "",
      manageAddressesHref: "",
      manageCheckingAccountsHref: "",
      reportsHref: "",
      usersHref: "",
      groupsHref: "",
      manageRecurringPaymentsHref: "",
      displayHistory: false,
      displayAdvancedReporting: false,
      displayUsers: false,
      displayGroups: false,
      displayCreditCards: false,
      displayAddresses: false,
      displayManageAch: false,
      displayAccountCenterDashboard: false,
      displayRecurringPayments: false,
    };
  }
  componentDidMount() {
    this.subsToUnsubscribe.push(
        forkJoin(
            [
                ConfigPropService.get([ConfigProps.EnableResponsiveManageAddresses]),
                NavigationTokensService.get([
                    NavigationTokens.accountStatement,
                    NavigationTokens.invoiceHistory,
                    NavigationTokens.reports,
                    NavigationTokens.manageUsers,
                    NavigationTokens.manageGroups,
                    NavigationTokens.manageAddresses,
                    NavigationTokens.manageExpenseAllocations,
                    NavigationTokens.manageCreditCards,
                    NavigationTokens.manageCheckingAccounts,
                    NavigationTokens.budgets,
                    NavigationTokens.workflow,
                    NavigationTokens.ManageRecurringPayments,
                    NavigationTokens.OISignup,])
              ]
            )
        .subscribe((responses) => {
            const configProps = responses[0]
            const navTokens = responses[1];

            var enableResponsiveManageAddresses = ConfigPropService.isYesOrTrue(configProps[ConfigProps.EnableResponsiveManageAddresses]);

            const responsiveManageAddressesLink = WBMUrlService.getManageAddressesUrl(
                BaseHostUrlService.get(),
                `${enableResponsiveManageAddresses ? EnvironmentService.get().ecomVnextUrl : EnvironmentService.get().ecom}`,
                enableResponsiveManageAddresses);

            this.setState({
                invoiceHistoryHref: navTokens[NavigationTokens.invoiceHistory],
                manageCreditCardsHref: navTokens[NavigationTokens.manageCreditCards],
                manageAddressesHref: enableResponsiveManageAddresses ? responsiveManageAddressesLink : navTokens[NavigationTokens.manageAddresses],
                manageCheckingAccountsHref:
                    navTokens[NavigationTokens.manageCheckingAccounts],
                reportsHref: navTokens[NavigationTokens.reports],
                usersHref: navTokens[NavigationTokens.manageUsers],
                groupsHref: navTokens[NavigationTokens.manageGroups],
                manageRecurringPaymentsHref:
                    navTokens[NavigationTokens.ManageRecurringPayments],
            });

            this.subsToUnsubscribe.push(
                MenuItemService.onlineInvoicingSignUpUrl().subscribe((value) => {
                    this.setState({
                        invoicesAndPaymentsHref: value
                            ? navTokens[NavigationTokens.OISignup]
                            : navTokens[NavigationTokens.accountStatement],
                    });
                })
            );
        })
    );

    this.subsToUnsubscribe.push(
      MenuItemService.displayHistory().subscribe((value) => {
        this.setState({
          displayHistory: value,
        });
      })
    );

    this.subsToUnsubscribe.push(
      MenuItemService.displayAdvancedReporting().subscribe((value) => {
        this.setState({
          displayAdvancedReporting: value,
        });
      })
    );

    this.subsToUnsubscribe.push(
      MenuItemService.displayGroups().subscribe((value) => {
        this.setState({
          displayGroups: value,
        });
      })
    );

    this.subsToUnsubscribe.push(
      MenuItemService.displayCreditCards().subscribe((value) => {
        this.setState({
          displayCreditCards: value,
        });
      })
    );

    this.subsToUnsubscribe.push(
      MenuItemService.displayUsers().subscribe((value) => {
        this.setState({
          displayUsers: value,
        });
      })
    );

    this.subsToUnsubscribe.push(
      MenuItemService.displayAddresses().subscribe(({manageShipping, editBilling}) => {
        this.setState({ 
          displayAddresses: manageShipping || editBilling, 
        });
      })
    );

    this.subsToUnsubscribe.push(
      MenuItemService.displayManageAch().subscribe((value) => {
        this.setState({
          displayManageAch: value,
        });
      })
    );

    this.subsToUnsubscribe.push(
      MenuItemService.displayAccountCenterDashboard().subscribe((value) => {
        this.setState({
          displayAccountCenterDashboard: value,
        });
      })
    );

    this.subsToUnsubscribe.push(
      MenuItemService.displayRecurringPayments().subscribe((value) => {
        this.setState({
          displayRecurringPayments: value,
        });
      })
    );
  }

  componentWillUnmount() {
    for (const sub of this.subsToUnsubscribe) {
      sub.unsubscribe();
    }
  }

  render() {
    return (
      <>
        {this.state.displayAccountCenterDashboard && (
          <MenuItem icon="dashboard" label="Account Center Dashboard" />
        )}

        {this.state.invoicesAndPaymentsHref && (
          <MenuItem
            icon="article"
            href={this.state.invoicesAndPaymentsHref}
            label="Account Statement"
          />
        )}

        {this.state.displayHistory && (
          <MenuItem
            icon="history"
            label="History"
            href={this.state.invoiceHistoryHref}
          />
        )}

        {this.state.displayAdvancedReporting && (
          <MenuItem
            icon="insights"
            label="Advanced Reporting"
            href={this.state.reportsHref}
          />
        )}

        <MenuItemDivider />

        {this.state.displayUsers && (
          <MenuItem icon="person" label="Users" href={this.state.usersHref} />
        )}

        {this.state.displayGroups && (
          <MenuItem
            icon="credit_card"
            label="Groups"
            href={this.state.groupsHref}
          />
        )}

        {this.state.displayCreditCards && (
          <MenuItem
            icon="credit_card"
            label="Credit Cards"
            href={this.state.manageCreditCardsHref}
          />
        )}

        {this.state.displayAddresses && (
          <MenuItem
            icon="location_on"
            label="Addresses"
            href={this.state.manageAddressesHref}
          />
        )}

        {this.state.displayManageAch && (
          <MenuItem
            icon="account_balance"
            label="Manage ACH"
            href={this.state.manageCheckingAccountsHref}
          />
        )}

        {this.state.displayRecurringPayments && (
          <MenuItem
            icon="repeat"
            label="Recurring Payments"
            href={this.state.manageRecurringPaymentsHref}
          />
        )}

        <MenuItemDivider />

        <YourRepresentative
          repType={RepTypes.accountsReceivable}
          isDesktop={false}
        />

        <MenuItemDivider />

        <YourBillingCycle />
      </>
    );
  }
}

export default AccountAndPaymentsMenu;
